var map = {
	"./digital-store-product-01.jpg": 7987,
	"./digital-store-product-02.jpg": 9949,
	"./digital-store-product-03.jpg": 4570,
	"./digital-store-product-04.jpg": 1396,
	"./digital-store-product-05.jpg": 9706,
	"./digital-store-product-06.jpg": 5690,
	"./digital-store-product-07.jpg": 4323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7237;